const floorStatics = {
  p0_w: {
    sectionPath: '/floor_0',
    locationKey: 'p0_w',
    sectionKey: 'WOMAN',
    floorKey: '0',
    section: 'p0_w.section.name',
    floor: 'p0_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W.pdf.jpg?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_w.path.floorMap.linkName',
        title: 'p0_w.path.floorMap.title',
        info: 'p0_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.floorMap.description.title',
          content: 'p0_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p0_w.path.shoes.linkName',
        title: 'p0_w.path.shoes.title',
        info: 'p0_w.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_Calzado_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_Calzado.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.shoes.description.title',
          content: 'p0_w.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/lingerie',
        exact: true,
        location: 'lingerie',
        linkName: 'p0_w.path.lingerie.linkName',
        title: 'p0_w.path.lingerie.title',
        info: 'p0_w.path.lingerie.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_Lenceria_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_Lenceria.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.lingerie.description.title',
          content: 'p0_w.path.lingerie.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p0_w.path.selfCheckout.linkName',
        title: 'p0_w.path.selfCheckout.title',
        info: 'p0_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.selfCheckout.description.title',
          content: 'p0_w.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/payAndGo',
        exact: true,
        location: 'payAndGo',
        linkName: 'p0_w.path.payAndGo.linkName',
        title: 'p0_w.path.payAndGo.title',
        info: 'p0_w.path.payAndGo.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_Pay&Go_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_Pay&Go.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.payAndGo.description.title',
          content: 'p0_w.path.payAndGo.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/onlinePickup',
        exact: true,
        location: 'onlinePickup',
        linkName: 'p0_w.path.onlinePickup.linkName',
        title: 'p0_w.path.onlinePickup.title',
        info: 'p0_w.path.onlinePickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_PuntoRecogidaOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_PuntoRecogidaOnline.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.onlinePickup.description.title',
          content: 'p0_w.path.onlinePickup.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p0_w.path.pickUpSize.linkName',
        title: 'p0_w.path.pickUpSize.title',
        info: 'p0_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_W_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.pickUpSize.description.title',
          content: 'p0_w.path.pickUpSize.description.content',
        },
      },
    ],
  },
  p1_m: {
    sectionPath: '/floor_1',
    locationKey: 'p1_m',
    sectionKey: 'WOMAN',
    floorKey: '1',
    section: 'p1_m.section.name',
    floor: 'p1_m.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M.pdf.jpg?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_1',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p1_m.path.floorMap.linkName',
        title: 'p1_m.path.floorMap.title',
        info: 'p1_m.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_m.path.floorMap.description.title',
          content: 'p1_m.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/athleticz',
        exact: true,
        location: 'athleticz',
        linkName: 'p1_m.path.athleticz.linkName',
        title: 'p1_m.path.athleticz.title',
        info: 'p1_m.path.athleticz.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M_Athleticz_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M_Athleticz.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_m.path.athleticz.description.title',
          content: 'p1_m.path.athleticz.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p1_m.path.shoes.linkName',
        title: 'p1_m.path.shoes.title',
        info: 'p1_m.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M_Calzado_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M_Calzado.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_m.path.shoes.description.title',
          content: 'p1_m.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/payAndGo',
        exact: true,
        location: 'payAndGo',
        linkName: 'p1_m.path.payAndGo.linkName',
        title: 'p1_m.path.payAndGo.title',
        info: 'p1_m.path.payAndGo.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M_Pay&Go_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M_Pay&Go.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_m.path.payAndGo.description.title',
          content: 'p1_m.path.payAndGo.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p1_m.path.pickUpSize.linkName',
        title: 'p1_m.path.pickUpSize.title',
        info: 'p1_m.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P0_M_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_m.path.pickUpSize.description.title',
          content: 'p1_m.path.pickUpSize.description.content',
        },
      },
    ],
  },
  p2_w: {
    sectionPath: '/floor_2',
    locationKey: 'p2_w',
    sectionKey: 'WOMAN',
    floorKey: '2',
    section: 'p2_w.section.name',
    floor: 'p2_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W.pdf.jpg?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_2',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p2_w.path.floorMap.linkName',
        title: 'p2_w.path.floorMap.title',
        info: 'p2_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_w.path.floorMap.description.title',
          content: 'p2_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p2_w.path.selfCheckout.linkName',
        title: 'p2_w.path.selfCheckout.title',
        info: 'p2_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_w.path.selfCheckout.description.title',
          content: 'p2_w.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/onlineReturn',
        exact: true,
        location: 'onlineReturn',
        linkName: 'p2_w.path.onlineReturn.linkName',
        title: 'p2_w.path.onlineReturn.title',
        info: 'p2_w.path.onlineReturn.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_DevolucionesOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_DevolucionesOnline.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_w.path.onlineReturn.description.title',
          content: 'p2_w.path.onlineReturn.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p2_w.path.fittingRooms.linkName',
        title: 'p2_w.path.fittingRooms.title',
        info: 'p2_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_w.path.fittingRooms.description.title',
          content: 'p2_w.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/pickup',
        exact: true,
        location: 'pickup',
        linkName: 'p2_w.path.pickup.linkName',
        title: 'p2_w.path.pickup.title',
        info: 'p2_w.path.pickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_RecogidaRopa_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_RecogidaRopa.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_w.path.pickup.description.title',
          content: 'p2_w.path.pickup.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/repairs',
        exact: true,
        location: 'repairs',
        linkName: 'p2_w.path.repairs.linkName',
        title: 'p2_w.path.repairs.title',
        info: 'p2_w.path.repairs.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_Repairs_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_Repairs.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_w.path.repairs.description.title',
          content: 'p2_w.path.repairs.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/refunds',
        exact: true,
        location: 'refunds',
        linkName: 'p2_w.path.refunds.linkName',
        title: 'p2_w.path.refunds.title',
        info: 'p2_w.path.refunds.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_Devoluciones_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_Devoluciones.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_w.path.refunds.description.title',
          content: 'p2_w.path.refunds.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p2_w.path.pickUpSize.linkName',
        title: 'p2_w.path.pickUpSize.title',
        info: 'p2_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_W_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_w.path.pickUpSize.description.title',
          content: 'p2_w.path.pickUpSize.description.content',
        },
      },
    ],
  },
  p3_k: {
    sectionPath: '/floor_3',
    locationKey: 'p3_k',
    sectionKey: 'WOMAN',
    floorKey: '3',
    section: 'p3_k.section.name',
    floor: 'p3_k.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_K.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_K.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_3',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p3_k.path.floorMap.linkName',
        title: 'p3_k.path.floorMap.title',
        info: 'p3_k.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_K.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_K.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p3_k.path.floorMap.description.title',
          content: 'p3_k.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_3',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p3_k.path.selfCheckout.linkName',
        title: 'p3_k.path.selfCheckout.title',
        info: 'p3_k.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_K_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_K_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p3_k.path.selfCheckout.description.title',
          content: 'p3_k.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_3',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p3_k.path.pickUpSize.linkName',
        title: 'p3_k.path.pickUpSize.title',
        info: 'p3_k.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_K_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_K_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p3_k.path.pickUpSize.description.title',
          content: 'p3_k.path.pickUpSize.description.content',
        },
      },
    ],
  },
  p4_zh: {
    sectionPath: '/floor_4',
    locationKey: 'p4_zh',
    sectionKey: 'ZARA HOME',
    floorKey: '4',
    section: 'p4_zh.section.name',
    floor: 'p4_zh.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_ZH.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_ZH.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_4',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p4_zh.path.floorMap.linkName',
        title: 'p4_zh.path.floorMap.title',
        info: 'p4_zh.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_ZH.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_ZH.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p4_zh.path.floorMap.description.title',
          content: 'p4_zh.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_4',
        path: '/zaraHome',
        exact: true,
        location: 'zaraHome',
        linkName: 'p4_zh.path.zaraHome.linkName',
        title: 'p4_zh.path.zaraHome.title',
        info: 'p4_zh.path.zaraHome.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_ZH_ZaraHome_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/14512_P1_ZH_ZaraHome.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p4_zh.path.zaraHome.description.title',
          content: 'p4_zh.path.zaraHome.description.content',
        },
      },
    ],
  },
};

const StoreSuportedLanguages = [
  {
    language: 'en-GB',
    name: 'English',
  },
];

const HomeStatics = {
  splash:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_008.jpg?ts=1631201500000',
  prehome:
    'https://static.zara.net/photos/contents/multichannel/maps/14512_ZARA_BATTERSEA_IMG.jpg?ts=1631201500000',
  prehomeColor: '#fff',
};

const StoreConfig = {
  floorStatics,
  StoreSuportedLanguages,
  HomeStatics,
};

export default StoreConfig;
